import { getCallConferenceAgent, getCallSessionAgentUserId, getCallTransferAgent } from "../api";
import { callAPi } from "../CallService";
import { getAgentPhoneForCallingKrmId } from "../helpers";

export const getApiParams = (callFlow, agent) => {
  const data = {
    user_id: getCallSessionAgentUserId(),
    cm_access_key: null,
    freeswitch: callFlow.state.callEvent["FreeSWITCH_IPv4"],
    uuid: callFlow.state.firstAgentCallEvent["unique_id"],
    ivr_display_number: callFlow.state.callEvent["knowlarity_number"],
    to: getAgentPhoneForCallingKrmId(agent),
    queue_id: callFlow.state.callEvent["variable_cc_queue"]
      ? callFlow.state.callEvent["variable_cc_queue"]
      : null,
  };
  return data;
};

export const obdcc = {
  CALL_ACTIONS: {
    TRANSFER_CALL: async (callFlow, agent) => {
      const data1 = getApiParams(callFlow, agent);
      data1["type"] = "att_xfer";
      let data = new FormData();
      Object.keys(data1).map((key) => {
        data.append(key, data1[key]);
      });
      const response = await callAPi(
        "/newsr/sr_callcenter/transfer_call/",
        "POST",
        data
      );
      return response;
    },
    CONFERENCE_CALL: async (callFlow, agent) => {
      const data1 = getApiParams(callFlow, agent);
      data1["type"] = "complete";
      let data = new FormData();
      Object.keys(data1).map((key) => {
        data.append(key, data1[key]);
      });
      const response = await callAPi(
        "/newsr/sr_callcenter/transfer_call/",
        "POST",
        data
      );
      return response;
    },
    CONFERENCE_CALL_CANCEL: async (callFlow, agent) => {
      const isLegCAgent = (getCallTransferAgent()?.contact_number || getCallConferenceAgent()?.contact_number || getAgentPhoneForCallingKrmId(agent)).includes('@');
      const data1 = getApiParams(callFlow, agent);
      data1["type"] = "cancel";
      data1["uuid"] = ((isLegCAgent && sessionStorage.getItem('legcuuid')) || (isLegCAgent && callFlow.state.callEvent["unique_id"]) || callFlow.state.firstAgentCallEvent["unique_id"]);
      data1["to"] = (getCallTransferAgent()?.contact_number || getCallConferenceAgent()?.contact_number || getAgentPhoneForCallingKrmId(agent));
      let data = new FormData();
      Object.keys(data1).map((key) => {
        data.append(key, data1[key]);
      });
      const response = await callAPi(
        "/newsr/sr_callcenter/transfer_call/",
        "POST",
        data
      );
      return response;
    },
    CONFERENCE_HOLD: async (callFlow, agent) => {
      const data1 = getApiParams(callFlow, agent);
      data1["type"] = "hold";
      if(sessionStorage.getItem("legcuuid") && callFlow.state.call_type === "legc_call") {
        data1["uuid"] = sessionStorage.getItem("legcuuid");
      }
      let data = new FormData();
      Object.keys(data1).map((key) => {
        data.append(key, data1[key]);
      });
      const response = await callAPi(
        "/newsr/sr_callcenter/transfer_call/",
        "POST",
        data
      );
      return response;
    },
    CONFERENCE_UNHOLD: async (callFlow, agent) => {
      const data1 = getApiParams(callFlow, agent);
      data1["type"] = "unhold";
      if(sessionStorage.getItem("legcuuid") && callFlow.state.call_type === "legc_call") {
        data1["uuid"] = sessionStorage.getItem("legcuuid");
      }
      let data = new FormData();
      Object.keys(data1).map((key) => {
        data.append(key, data1[key]);
      });
      const response = await callAPi(
        "/newsr/sr_callcenter/transfer_call/",
        "POST",
        data
      );
      return response;
    },

    AGENT_LIST_API: async (callFlow, params) => {
      return await callAPi("/newsr/api/v1/warm_call_agents/", "GET", params);
    },
  },
};
